import { render } from "./Procena360Eng.vue?vue&type=template&id=45e58aa2&scoped=true&lang=html"
import script from "./Procena360Eng.vue?vue&type=script&lang=js"
export * from "./Procena360Eng.vue?vue&type=script&lang=js"

import "./Procena360Eng.vue?vue&type=style&index=0&id=45e58aa2&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-45e58aa2"

export default script